var CollaborationServiceSetup = /** @class */ (function () {
    function CollaborationServiceSetup() {
    }
    CollaborationServiceSetup.Initialize = function (client) {
        this._client = client;
    };
    Object.defineProperty(CollaborationServiceSetup, "client", {
        get: function () {
            return this._client;
        },
        enumerable: true,
        configurable: true
    });
    return CollaborationServiceSetup;
}());
export { CollaborationServiceSetup };
//# sourceMappingURL=Setup.js.map